import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from './components/Login'
import { Home } from './pages/Home';
import { AuthProvider } from './context/AuthProvider';
import PublicRoute from './components/router/PublicRoute';
import ProtectedRoute from './components/router/ProtectedRoute';
import { LogOut } from './components/LogOut';
import { Perfil } from "./pages/Perfil";
import { Cotizador } from "./pages/Cotizador";
import { Consultas } from "./pages/Consultas";
import { Datos } from "./pages/Datos";
import { TasasABM } from "./pages/TasasABM";
import { Usuarios } from "./pages/Usuarios";
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material';
import { useMemo, useState, useCallback } from "react";
import { ThemeProvider } from './components/ThemeContext'; // Importa el ThemeProvider personalizado
import SuperProtectedRoute from './components/router/SuperProtectedRoutes';
import { ConsultaSituacion } from "./pages/ConsultaSituacion";

const storedTheme = localStorage.getItem('isDarkTheme') !== null
    ? Boolean(JSON.parse(localStorage.getItem('isDarkTheme')))
    : false;

export default function App() {
    const [isDarkMode, setIsDarkMode] = useState(storedTheme);

    const toggleDarkMode = useCallback(() => {
        setIsDarkMode((prevTheme) => {
            const newTheme = !prevTheme;
            localStorage.setItem('isDarkTheme', JSON.stringify(newTheme));
            return newTheme;
        });
    }, []);

    const theme = useMemo(
        () => createTheme({ palette: { mode: isDarkMode ? 'dark' : 'light' } }),
        [isDarkMode]
    );

    // Memoizar el valor del contexto
    const themeContextValue = useMemo(
        () => ({ isDarkMode, toggleDarkMode }),
        [isDarkMode, toggleDarkMode]
    );

    return (
        <>
            <MuiThemeProvider theme={theme}>
                <ThemeProvider isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode}>
                    <AuthProvider>
                        <BrowserRouter>
                            <Routes>
                                <Route path="/login" element={<PublicRoute />}>
                                    <Route path="/login" element={<Login />} />
                                </Route>
                                {/* Ruta ra�z: redirigir seg�n autenticaci�n */}
                                <Route
                                    path="/"
                                    element={
                                        <Navigate
                                            to={localStorage.getItem('loggedNoteAppUser') ? '/home' : '/login'}
                                            replace
                                        />
                                    }
                                />
                                <Route element={<SuperProtectedRoute />}>
                                    <Route path="/consultas" element={<Consultas />} />
                                    <Route path="/situacion" element={<ConsultaSituacion />} />
                                    <Route path="/usuarios" element={<Usuarios />} />
                                    <Route path="/datos" element={<Datos />} />
                                    <Route path="/tasas" element={<TasasABM />} />
                                </Route>
                                <Route element={<ProtectedRoute />}>
                                    <Route index element={<Home />} />
                                    <Route path="/logout" element={<LogOut />} />
                                    <Route path="/perfil" element={<Perfil />} />
                                    <Route path="/cotizador" element={<Cotizador />} />
                                </Route>
                                <Route path="*" element={<Navigate to="/" replace />} />
                            </Routes>
                        </BrowserRouter>
                    </AuthProvider>
                </ThemeProvider>
            </MuiThemeProvider>
        </>
    );
}